import { Grid } from "@mui/material";
import { Edit, SimpleForm } from "react-admin";
import CustomDateInput from "shared/components/inputs/CustomDateInput";

export default function CertificationsEdit() {
  return (
    <Edit>
      <SimpleForm>
        <Grid container>
          <Grid item xs={4}>
            <CustomDateInput source="certif_name" />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
}
